<div class="breadcrumbs">
  <div class="content-wrapper">
    <div class="breadcrumbs-container"> <a [routerLink]="'/'" class="breadcrumbs-link-home">Strona główna</a> &raquo; <span>Polityka prywatności</span> </div>
  </div>
</div>

<main class="page">
  <section class="tw-medium-padding">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">INFORMACJE O OCHRONIE DANYCH OSOBOWYCH W MS WORKS MICHAŁ SZEWCZYK</h3>
      </div>
      <p>
        MS WORKS Michał Szewczyk (dalej MS WORKS) przywiązuje dużą wagę do ochrony prywatności użytkowników podczas przetwarzania ich danych osobowych. W związku z tym MS WORKS przetwarza dane osobowe użytkowników zgodnie z odpowiednimi
        przepisami o ochronie danych, w szczególności z ogólnym rozporządzeniem o ochronie danych (RODO) i zasadami opisanymi poniżej.
      </p>
    </div>
  </section>

  <section class="tw-medium-padding tw-secondary">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">1. INFORMACJE O ADMINISTRATORZE</h3>
      </div>
      <p> Nazwa oraz dane kontaktowe administratora: </p>
      <p>
        MS WORKS Michał Szewczyk<br />
        ul. Chabrowa 73A<br />
        05-084 Wilkowa Wieś, Polska<br />
        E-mail: &#98;&#105;&#117;&#114;&#111;&#64;&#109;&#101;&#98;&#108;&#101;&#46;&#112;&#114;&#111;
      </p>
      <p> Dane kontaktowe inspektora ochrony danych / zespołu ds. ochrony danych administratora: </p>
      <p>
        MS WORKS Michał Szewczyk<br />
        Inspektor Ochrony Danych<br />
        ul. Chabrowa 73A<br />
        05-084 Wilkowa Wieś, Polska<br />
        E-mail: &#105;&#111;&#100;&#64;&#109;&#101;&#98;&#108;&#101;&#46;&#112;&#114;&#111;
      </p>
    </div>
  </section>

  <section class="tw-medium-padding">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">2. INFORMACJE O PRAWACH OSÓB, KTÓRYCH DANE DOTYCZĄ</h3>
      </div>
      <p> Jeśli spełnione są odpowiednie warunki, użytkownikowi przysługują następujące prawa: </p>
      <ul>
        <li>Prawo do informacji, art. 15 RODO</li>
        <li>Prawo do sprostowania, art. 16 RODO</li>
        <li>Prawo do usunięcia danych, art. 17 RODO</li>
        <li>Prawo do ograniczenia przetwarzania, art. 18 RODO</li>
        <li>Prawo do przenoszenia danych, art. 20 RODO</li>
        <li>
          Prawo do sprzeciwu, art. 21 RODO<br />
          <i
            >Zgodnie z art. 21 ust. 1 RODO użytkownik ma prawo w dowolnym momencie wnieść sprzeciw wobec przetwarzania jego danych osobowych na podstawie art. 6 ust. 1 lit. e lub f RODO z przyczyn związanych z jego szczególną sytuacją, w
            tym profilowania. Zgodnie z art. 21 ust. 2 RODO użytkownik ma prawo w dowolnym momencie wnieść sprzeciw wobec przetwarzania jego danych osobowych do celów marketingu bezpośredniego, w tym profilowania, jeśli i w zakresie, w
            jakim dotyczy to marketingu bezpośredniego.</i
          >
        </li>

        <li>Prawo do wycofania zgody, art. 7 ust. 3 RODO</li>
        <li>
          Prawo do wniesienia skargi do właściwego organu nadzorczego, art. 77 ust. 1 RODO<br />
          <i>Użytkownik może wnieść skargę do organu nadzorczego właściwego dla jego miejsca zamieszkania / kraju związkowego lub do organu nadzorczego właściwego dla nas.</i>
        </li>
      </ul>

      <p>Organem nadzorczym właściwym dla nas jest:</p>
      <p>
        Prezes Urzędu Ochrony Danych Osobowych<br />
        ul. Stanisława Moniuszki 1A<br />
        00-014 Warszawa, Polska<br />
        kancelaria&#64;uodo.gov.pl
      </p>
      <p>Aby dochodzić swoich praw, należy skorzystać z danych kontaktowych wymienionych w punkcie 1. Prosimy o upewnienie się, że będziemy w stanie jednoznacznie zidentyfikować użytkownika.</p>
    </div>
  </section>

  <section class="tw-medium-padding tw-secondary">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3. INFORMACJE O PRZETWARZANIU DANYCH OSOBOWYCH</h3>
      </div>
      <p> Podczas korzystania z naszych usług przetwarzane są różne dane osobowe w różnych celach. Poniżej informujemy o odpowiednich procesach przetwarzania. </p>
    </div>
  </section>

  <section class="tw-medium-padding">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3.1 ŚLEDZENIE / PLIKI COOKIE</h3>
      </div>
      <p>
        Podczas korzystania z naszych usług dane osobowe mogą być przetwarzane w ramach śledzenia. Na naszej stronie internetowej używamy plików cookie do celów śledzenia. Pliki cookie to małe pakiety danych, które przeglądarki internetowe
        lub strony internetowe generują i przechowują lokalnie na urządzeniu końcowym. Zawierają one ciągi znaków, które mogą być wykorzystane do identyfikacji danego urządzenia końcowego i ostatecznie użytkownika jako osoby fizycznej
        korzystającej z urządzenia końcowego. Za pomocą plików cookie można udokumentować indywidualną ścieżkę przez Internet w sposób identyfikowalny, ponadto w ten sposób można przechowywać dane logowania, zachowanie podczas podczas
        przeglądania stron, indywidualne ustawienia i wiele innych danych („śledzenie”).
      </p>
      <p>
        Używamy różnych rodzajów plików cookie, które umożliwiają śledzenie. Rozróżniamy trzy kategorie plików: niezbędne, funkcjonalne i marketingowe. Szczegółowe informacje na temat tego, co kryje się za poszczególnymi kategoriami, które
        pliki cookie są przypisane do poszczególnych kategorii, celów przetwarzania, konkretnych danych osobowych, które przetwarzamy w celu śledzenia i okresu przechowywania, można znaleźć tutaj:
        <a href="" (click)="openCookieSettings($event)">Cookies</a>.
      </p>
    </div>
  </section>

  <section class="tw-medium-padding tw-secondary">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3.2 KORZYSTANIE ZE STRONY INTERNETOWEJ</h3>
      </div>
      <p>
        Podczas korzystania z naszej strony internetowej automatycznie gromadzone są pewne dane osobowe. Jest to podyktowane względami technicznymi. Bez tych danych nie możemy dostarczyć użytkownikowi treści, do których uzyskał dostęp.
      </p>

      <div class="grid tw-secondary">
        <div class="grid-row">
          <b>Kategorie danych osobowych</b>
          <div>Dane online</div>
        </div>
        <div class="grid-row">
          <b>Dane osobowe, zawarte w kategoriach</b>
          <div> Adres IP, port, status protokołu, data i godzina dostępu, nazwa otwieranego pliku/strony internetowej, typ i wersja przeglądarki internetowej, poprzednio otwierana strona internetowa (adres URL odsyłacza) </div>
        </div>
        <div class="grid-row">
          <b>Cel</b>
          <div> Zapewnienie dostępu do treści strony internetowej, zapewnienie bezpieczeństwa wykorzystywanej infrastruktury IT </div>
        </div>
        <div class="grid-row">
          <b>Podstawa prawna</b>
          <div>
            Wyważenie interesów, art. 6 ust. 1 lit. f RODO<br />
            Oprócz dostarczania treści strony internetowej, do której dostęp uzyskuje użytkownik, naszym prawnie uzasadnionym interesem jest zapewnienie bezpieczeństwa wykorzystywanej infrastruktury informatycznej (wykrywanie, usuwanie,
            zabezpieczanie dowodów).
          </div>
        </div>
        <div class="grid-row">
          <b>Kategorie odbiorców</b>
          <div>
            Podmioty przetwarzające (dostawcy usług hostingowych, odbiorcy wewnątrzfirmowi)<br />
            <i>Obecnie nie przekazujemy danych użytkownika podmiotom przetwarzającym z siedzibą w kraju trzecim</i>
          </div>
        </div>
        <div class="grid-row">
          <b>Czas przechowywania</b>
          <div>30 dni</div>
        </div>
        <div class="grid-row">
          <b>Obowiązek podania</b>
          <div>Podanie wyżej wymienionych danych nie jest wymagane przez prawo lub w celu zawarcia umowy. Jeśli jednak dane nie zostaną podane, strona internetowa nie będzie dostępna.</div>
        </div>
      </div>
    </div>
  </section>

  <section class="tw-medium-padding">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3.3 FORMULARZ KONTAKTOWY</h3>
      </div>
      <p> Użytkownik ma możliwość skontaktowania się z nami za pomocą formularza kontaktowego. </p>

      <div class="grid">
        <div class="grid-row">
          <b>Kategorie danych osobowych</b>
          <div> Dane online, dane podstawowe, inne dane użytkownika </div>
        </div>
        <div class="grid-row">
          <b>Dane osobowe, zawarte w kategoriach</b>
          <div> Adres IP, imię i nazwisko, adres e-mail, numer telefonu, informacje z formularza kontaktowego </div>
        </div>
        <div class="grid-row">
          <b>Cel</b>
          <div> Przetwarzanie zapytania wraz z informacją zwrotną </div>
        </div>
        <div class="grid-row">
          <b>Podstawa prawna</b>
          <div>
            Wyważenie interesów, art. 6 ust. 1 lit. f RODO<br />
            Naszym prawnie uzasadnionym interesem jest przetwarzanie zapytania.
          </div>
        </div>
        <div class="grid-row">
          <b>Kategorie odbiorców</b>
          <div>
            Podmioty przetwarzające (dostawcy usług hostingowych, odbiorcy wewnątrzfirmowi)<br />
            <i>Obecnie nie przekazujemy danych użytkownika podmiotom przetwarzającym z siedzibą w kraju trzecim</i>
          </div>
        </div>
        <div class="grid-row">
          <b>Czas przechowywania</b>
          <div>
            Dane użytkownika będą przechowywane
            <ul>
              <li>
                w celu zabezpieczenia dowodów na potrzeby ewentualnego ustalenia, dochodzenia lub obrony roszczeń przez okres 3 lat od końca roku, w którym użytkownik skontaktował się z nami<br />
                lub do czasu zakończenia wszelkich sporów prawnych.
              </li>
            </ul>
          </div>
        </div>
        <div class="grid-row">
          <b>Obowiązek podania</b>
          <div> Podanie wyżej wymienionych danych nie jest wymagane przez prawo lub w celu zawarcia umowy. Jeśli jednak dane nie zostaną podane, zapytanie nie będzie mogło zostać przetworzone. </div>
        </div>
      </div>
    </div>
  </section>

  <section class="tw-medium-padding tw-secondary">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3.4 KIEDY UŻYTKOWNIK SIĘ Z NAMI KONTAKTUJE</h3>
      </div>
      <p>
        Użytkownik może również w dowolnym momencie skontaktować się z nami telefonicznie lub za pośrednictwem poczty elektronicznej. W zależności od sprawy użytkownika (np. ogólne zapytania, skargi/sugestie) przetwarzamy następujące dane
        użytkownika.
      </p>

      <div class="grid tw-secondary">
        <div class="grid-row">
          <b>Kategorie danych osobowych</b>
          <div>Dane podstawowe, cechy fizyczne</div>
        </div>
        <div class="grid-row">
          <b>Dane osobowe, zawarte w kategoriach</b>
          <div> Imię i nazwisko, adres, adres e-mail, numer telefonu, płeć </div>
        </div>
        <div class="grid-row">
          <b>Cel</b>
          <div> Przetwarzanie sprawy. </div>
        </div>
        <div class="grid-row">
          <b>Podstawa prawna</b>
          <div>
            Zgoda, art. 6 ust. 1 lit. a RODO<br />
            Wykonanie umowy, art. 6 ust. 1 lit. b RODO<br />
            W zależności od sprawy, przetwarzanie wyżej wymienionych danych może być konieczne w kontekście wykonania umowy.
          </div>
        </div>
        <div class="grid-row">
          <b>Kategorie odbiorców</b>
          <div>
            Podmioty przetwarzające (dostawcy usług hostingowych, odbiorcy wewnątrzfirmowi, dostawcy usług poczty elektronicznej)<br />
            <i>Obecnie nie przekazujemy danych użytkownika podmiotom przetwarzającym z siedzibą w kraju trzecim</i>
          </div>
        </div>
        <div class="grid-row">
          <b>Czas przechowywania</b>
          <div>
            Dane użytkownika będą przechowywane
            <ul>
              <li> do czasu całkowitego załatwienia sprawy użytkownika </li>
              <li>
                w celu zabezpieczenia dowodów na potrzeby ewentualnego ustalenia, dochodzenia lub obrony roszczeń prawnych przez okres 3 lat od końca roku, w którym użytkownik skontaktował się z nami<br />
                lub do czasu zakończenia wszelkich sporów prawnych
              </li>
              <li> przez 6 lub 10 lat w ramach ustawowych obowiązków przechowywania (zgodnie z prawem handlowym i podatkowym). </li>
            </ul>
          </div>
        </div>
        <div class="grid-row">
          <b>Obowiązek podania</b>
          <div> Podanie wyżej wymienionych danych jest niezbędne do zawarcia umowy. Jeśli dane nie zostaną podane, realizacja usług nie będzie możliwa. </div>
        </div>
      </div>
    </div>
  </section>

  <section class="tw-medium-padding">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">3.5 KIEDY UŻYTKOWNIK ZAWRZE Z NAMI UMOWĘ HANDLOWĄ</h3>
      </div>
      <p> Użytkownik może zawrzeć z nami umowę handlową. Przetwarzamy wtedy następujące dane użytkownika. </p>

      <div class="grid">
        <div class="grid-row">
          <b>Kategorie danych osobowych</b>
          <div>Dane podstawowe, cechy fizyczne</div>
        </div>
        <div class="grid-row">
          <b>Dane osobowe, zawarte w kategoriach</b>
          <div> Imię i nazwisko, adres, adres e-mail, numer telefonu, płeć, numer dowodu osobistego </div>
        </div>
        <div class="grid-row">
          <b>Cel</b>
          <div> Realizacja umowy oraz usług gwarancyjnych z niej wynikających. </div>
        </div>
        <div class="grid-row">
          <b>Podstawa prawna</b>
          <div>
            Zgoda, art. 6 ust. 1 lit. a RODO<br />
            Wykonanie umowy, art. 6 ust. 1 lit. b RODO<br />
            Przetwarzanie wyżej wymienionych danych jest konieczne w kontekście wykonania umowy.
          </div>
        </div>
        <div class="grid-row">
          <b>Kategorie odbiorców</b>
          <div> Podmioty przetwarzające (odbiorcy wewnątrzfirmowi) </div>
        </div>
        <div class="grid-row">
          <b>Czas przechowywania</b>
          <div>
            Dane użytkownika będą przechowywane
            <ul>
              <li> do czasu całkowitego zrealizowania umowy i zakończenia okresu gwarancyjnego </li>
              <li>
                w celu zabezpieczenia dowodów na potrzeby ewentualnego ustalenia, dochodzenia lub obrony roszczeń prawnych przez okres 3 lat od końca roku, w którym użytkownik zawarł z nami umowę<br />
                lub do czasu zakończenia wszelkich sporów prawnych
              </li>
              <li> przez 6 lub 10 lat w ramach ustawowych obowiązków przechowywania (zgodnie z prawem handlowym i podatkowym). </li>
            </ul>
          </div>
        </div>
        <div class="grid-row">
          <b>Obowiązek podania</b>
          <div> Podanie wyżej wymienionych danych jest niezbędne do zawarcia umowy. Jeśli dane nie zostaną podane, realizacja usług nie będzie możliwa. </div>
        </div>
      </div>
    </div>
  </section>

  <section class="tw-medium-padding tw-secondary">
    <div class="content-wrapper">
      <div class="section-header">
        <h3 class="section-title">4. STAN I ZMIANA INFORMACJI O OCHRONIE DANYCH</h3>
      </div>
      <p> Zastrzegamy sobie prawo do zmiany niniejszych informacji o ochronie danych w związku z rozwojem technicznym lub zmianami wymogów prawnych, bądź urzędowych. </p>
    </div>
  </section>
</main>
